import type { StaffUsers } from "../../types/experiment";
import { Switch } from "../ui/switch";
import { Label } from "../ui/label";

interface StaffFilterProps {
  value: StaffUsers;
  onChange: (value: StaffUsers) => void;
}

export function StaffFilter({ value, onChange }: StaffFilterProps) {
  return (
    <div className="space-y-2">
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-2">
          <Switch
            checked={value.work_accounts}
            onCheckedChange={(v) => onChange({ ...value, work_accounts: v })}
          />
          <Label className="text-xs">Work Accounts</Label>
        </div>
        <div className="flex items-center gap-2">
          <Switch
            checked={value.personal_accounts}
            onCheckedChange={(v) => onChange({ ...value, personal_accounts: v })}
          />
          <Label className="text-xs">Personal Accounts</Label>
        </div>
      </div>
    </div>
  );
}
